var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{staticClass:"hidden-md-and-down"},[_c('v-row',{staticStyle:{"background":"#F8F8F9","height":"101%"}},[_c('v-col',{attrs:{"cols":"12","md":"1","sm":"1","lg":"1"}},[_c('AdminSideBar')],1),_c('v-col',{attrs:{"cols":"12","md":"11","sm":"11","lg":"11"}},[_c('AppBar'),_c('DashboardComponent')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }